import React, {useState} from 'react';
import cls from 'classnames';
import styles from './Submenu.module.scss';
import IconChevronRight from '../../../../UI/Icons/IconChevronRight';

function Submenu({titleText, titleClassName, content, defaultIsOpen = false}) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <>
      <button className={titleClassName} onClick={handleToggle}>
        {titleText}
        <i className={cls(styles.icon, {[styles.active]: isOpen})}>
          <IconChevronRight/>
        </i>
      </button>
      {isOpen ? content : null}
    </>
  );
}

export default Submenu;
